import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function StarIcon(props: IIcon) {
    return (
        <Icon
            dropShadow={props.dropShadow}
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                id="star"
                d="M488.33,192a8.46,8.46,0,0,0-6.82-5.75L328.82,164.07,260.53,25.71a8.43,8.43,0,0,0-15.13,0L177.12,164.08,24.43,186.27a8.44,8.44,0,0,0-4.68,14.39l110.5,107.7L104.15,460.44a8.46,8.46,0,0,0,3.35,8.25,8.37,8.37,0,0,0,8.89.64L253,397.54l136.57,71.8a8.44,8.44,0,0,0,12.25-8.9L375.71,308.37,486.2,200.66A8.45,8.45,0,0,0,488.33,192Z"
            />
        </Icon>
    );
}
